import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage'; // Default localStorage for web
import postsReducer from './postsSlice';
import userReducer from './userSlice'; // Import userReducer

// Persist configuration
const persistConfig = {
  key: 'root', // Key to identify storage
  storage,     // Use localStorage as storage engine
};

// Persisted reducers
const persistedPostsReducer = persistReducer({ ...persistConfig, key: 'posts' }, postsReducer);
const persistedUserReducer = persistReducer({ ...persistConfig, key: 'user' }, userReducer);

// Configure store with persisted reducers
export const store = configureStore({
  reducer: {
    posts: persistedPostsReducer, // Posts state with persistence
    user: persistedUserReducer,   // User state with persistence
  },
  // Modify the middleware to allow non-serializable values
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'], // Ignore the persist actions for non-serializable data
        ignoredActionPaths: ['payload.register'], // Ignore specific paths that might contain non-serializable data
      },
    }),
});

// Persistor to control persisted store
export const persistor = persistStore(store);
